// Formatação compartilhada pelos componentes do Dashboard.

export const formatMinutes = (minutes) => {
  if (minutes === null || minutes === undefined || Number.isNaN(Number(minutes))) {
    return "—";
  }
  const total = Math.round(Number(minutes));
  if (total < 1) return "< 1m";

  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const mins = total % 60;

  if (days) return `${days}d ${hours}h`;
  if (hours) return `${hours}h ${String(mins).padStart(2, "0")}m`;
  return `${mins}m`;
};

export const formatNumber = (value) =>
  value === null || value === undefined ? "—" : Number(value).toLocaleString("pt-BR");

export const formatPercent = (value) =>
  value === null || value === undefined
    ? "—"
    : `${Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`;

/**
 * Variação percentual em relação ao período anterior.
 * `inverse`: quanto menor, melhor (ex.: tempo de espera).
 * Retorna null quando não há base de comparação.
 */
export const computeDelta = (current, previous, { inverse = false } = {}) => {
  if (current === null || current === undefined) return null;
  if (previous === null || previous === undefined || Number(previous) === 0) return null;

  const pct = ((Number(current) - Number(previous)) / Number(previous)) * 100;
  if (!Number.isFinite(pct)) return null;

  const rounded = Math.round(pct);
  return {
    value: rounded,
    good: rounded === 0 ? null : inverse ? rounded < 0 : rounded > 0,
  };
};

export const WEEKDAYS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];
